import request from "@/utils/request"
//订单列表
export function wxOAuthGetUserVo(data) {
  return request({
    url:'/user/wxOAuthGetUserVo',
    method:'post',
    data
  })
}
export function getUserInfo(data) {
  return request({
    url:'/user/getUserInfo',
    method:'post',
    data
  })
}
